"use client";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { ArrowLeft, RefreshCcw, Search, ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function SearchNotFound() {
    const router = useRouter();
    return (<div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="relative inline-flex items-center justify-center mb-6">
          <div className="absolute inset-0 bg-brand/10 blur-3xl rounded-full"/>
          <div className="relative w-24 h-24 rounded-full bg-card border border-border flex items-center justify-center">
            <Search className="w-10 h-10 text-muted-foreground"/>
          </div>
        </div>

        <h1 className="text-2xl font-bold text-foreground mb-2">
          未找到相关结果
        </h1>
        <p className="text-muted-foreground mb-8 leading-relaxed">
          抱歉，您的搜索条件没有匹配到任何车辆。请尝试调整关键词或使用更宽泛的筛选条件。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button size="lg" className="bg-brand hover:bg-brand-dark text-primary-foreground shadow-brand transition-all" onClick={() => router.push("/search", { scroll: false })}>
            <RefreshCcw className="w-4 h-4"/>
            重新搜索
          </Button>
          <Button size="lg" variant="outline" onClick={() => router.push("/", { scroll: false })}>
            <ArrowLeft className="w-4 h-4"/>
            返回首页
          </Button>
        </div>

        <div className="mt-10 pt-8 border-t border-border">
          <p className="text-sm text-muted-foreground mb-4">您可能还想浏览</p>
          <div className="flex items-center justify-center gap-4">
            <Link href="/listings" className="flex flex-col items-center gap-1.5 group">
              <div className="w-12 h-12 rounded-xl bg-brand-bg flex items-center justify-center group-hover:bg-brand-lighter transition-colors">
                <ShoppingCart className="w-5 h-5 text-brand"/>
              </div>
              <span className="text-xs text-muted-foreground group-hover:text-foreground transition-colors">
                全部车源
              </span>
            </Link>
            <Link href="/dealers" className="flex flex-col items-center gap-1.5 group">
              <div className="w-12 h-12 rounded-xl bg-brand-bg flex items-center justify-center group-hover:bg-brand-lighter transition-colors">
                <Search className="w-5 h-5 text-brand"/>
              </div>
              <span className="text-xs text-muted-foreground group-hover:text-foreground transition-colors">
                经销商
              </span>
            </Link>
            <Link href="/blog" className="flex flex-col items-center gap-1.5 group">
              <div className="w-12 h-12 rounded-xl bg-brand-bg flex items-center justify-center group-hover:bg-brand-lighter transition-colors">
                <Search className="w-5 h-5 text-brand"/>
              </div>
              <span className="text-xs text-muted-foreground group-hover:text-foreground transition-colors">
                购车指南
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>);
}
